import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export const useAppointmentPreview = (setAppointment = () => {}) => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const appointment_id = searchParams.get('appointment_id');

  useEffect(() => {
    if (appointment_id) {
      setAppointment({ id: appointment_id });
    }
  }, [appointment_id, setAppointment]);

  const openAppointment = (appointment) => {
    if (!appointment) return;
    if (appointment.isRecurrence) {
      setAppointment(appointment);
      return;
    }
    navigate(`?appointment_id=${appointment.id}`);
  };

  return { pathname, appointment_id, openAppointment };
};
